import ColorPicker from 'components/Widgets/ColorPicker';

const ColorTypeField = ({ selectItem, setNewSelectItem, item, disabled, forTable }) => {
  if (forTable) {
    return item.value !== '' ? (
      <div
        style={{ width: '30px', height: '30px', borderRadius: '100%', backgroundColor: item.value }}
      ></div>
    ) : (
      ''
    );
  } else {
    return (
      <ColorPicker
        selected={selectItem?.setting}
        onChange={(val) => {
          setNewSelectItem({
            value: val.color ?? ' ',
            setting: {
              color: val.color,
            },
          });
        }}
        item={item.value}
        disabled={disabled}
      />
    );
  }
};

export default ColorTypeField;
